/**
 * Created by matheusmorett on 14/06/18.
 */
import {observable, action} from 'mobx';

class NotificationStore {

    @observable notification = {
        message: "",
        type: ""
    };
    @observable hasNotification = false;

    @action
    setNotification(message, type = "default") {
        this.notification = {
            message: message,
            type: type
        };
        this.hasNotification = true;
    }

    @action
    getNotification() {
        if(!!this.hasNotification) {
            this.hasNotification = false;
            return this.notification;
        }
        return false;
    }
}

export default new NotificationStore();




// WEBPACK FOOTER //
// ./src/stores/NotificationStore.js